import { useMemo } from 'react';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { mergeInitialValues } from '@utils/formik';
import { useFormSchema, useFormValues } from '../InsurancePolicyBuyForm';

export const useInitialValues = (policy?: InsurancePolicy | null) => {
  const values = useFormValues();
  return useMemo(() => {
    if (policy) return mergeInitialValues(values, { ...policy, proof: undefined });
    return values;
  }, [policy]);
};

export const useValidationSchema = () => {
  const schema = useFormSchema();
  return schema.shape({
    proof: schema.fields.proof.optional(),
  });
};
